import Map from './Map/Map';

const RightPanel =({assets,event})=>{
    return(
        <Map assets={assets} event={event}/>
    )
}
export default RightPanel;